<div
  class="relative w-full h-full overflow-hidden"
  [class.pointer-events-none]="!isInteractive"
>
  @if (!showStream()) {
    <div class="absolute inset-0 flex flex-col items-center justify-center">
      <button
        class="border-gradient w-[150px] h-12 rounded-full text-white text-base font-medium flex items-center justify-center"
        [disabled]="!isInteractive"
        (click)="startStream()"
      >
        {{ 'COMPONENTS.PIXEL_STREAM.BUTTONS.START' | translate }}
      </button>
    </div>
  } @else {
    <iframe
      id="vagonFrame"
      class="absolute inset-0 w-full h-full border-none pointer-events-auto"
      [src]="streamUrl"
      allow="microphone *; clipboard-read *; clipboard-write *; encrypted-media *;"
      allowfullscreen
    ></iframe>
  }
</div>
